import { createStyles } from 'antd-style';
export var useStyles = createStyles(function () {
  return {
    container: {
      '& .ant-upload-list-picture-card': {
        display: 'flex',
        justifyContent: 'center'
      }
    }
  };
});